import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import './Receipt.css'; // The new CSS file we will create below

// --- IMPORTANT ---
// Make sure you have these logo files in the same folder,
// or update the paths to point to your assets directory.
import logo from "./logo.png";
import roundlogo from "./roundlogo.png";

const Receipt = forwardRef(({ appointment, patient }, ref) => {
    // Null check to prevent rendering errors if data is not yet available
    if (!appointment || !patient) {
        return <div className="receipt-loading">Loading receipt...</div>; // Or return null
    }

    const handlePrint = () => {
        window.print();
    };

    // Determine if the payment was successful to render the correct view
    const isSuccess = appointment.paymentStatus === 'paid';

    // If payment was not successful, show a failure message instead of a receipt
    if (!isSuccess) {
        return (
            <div className="receipt-container" ref={ref}>
                <div className="receipt-confirmation-card">
                    <div className="receipt-card-header">
                        <h2 className="receipt-status-title" style={{ color: '#d9534f' }}>Payment Failed</h2>
                        <p>A receipt could not be generated for this appointment.</p>
                        <p><strong>Reason:</strong> Payment was not successful.</p>
                        <p><strong>Order ID:</strong> {appointment.razorpayOrderId || 'N/A'}</p>
                    </div>
                </div>
            </div>
        );
    }

    const patientName = patient.name || `${patient.firstName || ''} ${patient.lastName || ''}`.trim();

    return (
        // The ref is attached to the main printable element
        <div className="receipt-main-wrapper" ref={ref}>
            <div className="receipt-content-area">
                <div className="receipt-container">
                    <div className="receipt-confirmation-card">
                        <div className="receipt-card-header">
                            <img src={logo} alt="Your Clinic Logo" className="receipt-logo" />
                            <div className="receipt-icon-wrapper">
                                <img style={{ height: '65px' }} src={roundlogo} alt="Clinic Emblem" />
                            </div>
                            <i className="fas fa-check-circle receipt-success-icon"></i>
                            <h2 className="receipt-status-title">Appointment Receipt</h2>
                            <p className="receipt-greeting-message">
                                Dear <strong>{patientName}</strong>, thank you for your payment. Your appointment details are below.
                            </p>
                        </div>

                        <div className="receipt-section receipt-highlight-section receipt-appointment-summary">
                            <h3 className="receipt-section-title">
                                <i className="fas fa-calendar-check"></i> Appointment Summary
                            </h3>
                            <div className="receipt-detail-grid">
                                <div className="receipt-detail-item prominent">
                                    <span className="receipt-detail-label">Doctor:</span>
                                    <span className="receipt-detail-value">{appointment.doctorDetails?.name || 'N/A'}</span>
                                </div>
                                <div className="receipt-detail-item prominent">
                                    <span className="receipt-detail-label">Date & Time:</span>
                                    <span className="receipt-detail-value">{new Date(appointment.appointmentDate).toLocaleDateString('en-GB')} at {appointment.appointmentTime}</span>
                                </div>
                                {appointment._id && (
                                    <div className="receipt-detail-item">
                                        <span className="receipt-detail-label">Booking ID:</span>
                                        <span className="receipt-detail-value receipt-booking-id">{appointment._id}</span>
                                        
                                    </div>
                                )}
                                {appointment.appointmentNumber && (
            <div className="receipt-detail-item">
                <span className="receipt-detail-label">Appointment No:</span>
                <span className="receipt-detail-value receipt-booking-id">{appointment.appointmentNumber || 'N/A'}</span>
            </div>
        )}
                            </div>
                        </div>

                        <div className="receipt-info-columns">
                            <div className="receipt-section receipt-payment-details">
                                <h3 className="receipt-section-title">
                                    <i className="fas fa-credit-card"></i> Payment Details
                                </h3>
                                <div className="receipt-detail-item">
                                    <span className="receipt-detail-label">Amount Paid:</span>
                                    <span className="receipt-detail-value receipt-amount-paid">₹{appointment.doctorFee?.toFixed(2) || 'N/A'}</span>
                                </div>
                                {appointment.razorpayPaymentId && (
                                    <div className="receipt-detail-item">
                                        <span className="receipt-detail-label">Payment ID:</span>
                                        <span className="receipt-detail-value">{appointment.razorpayPaymentId}</span>
                                    </div>
                                )}
                                {appointment.razorpayOrderId && (
                                    <div className="receipt-detail-item">
                                        <span className="receipt-detail-label">Order ID:</span>
                                        <span className="receipt-detail-value">{appointment.razorpayOrderId}</span>
                                    </div>
                                )}
                                <div className="receipt-detail-item">
                                    <span className="receipt-detail-label">Transaction Date:</span>
                                    <span className="receipt-detail-value">{new Date(appointment.createdAt || Date.now()).toLocaleString('en-GB')}</span>
                                </div>
                            </div>

                            <div className="receipt-section receipt-patient-info">
                                <h3 className="receipt-section-title">
                                    <i className="fas fa-user-circle"></i> Patient Information
                                </h3>
                                <div className="receipt-detail-item">
                                    <span className="receipt-detail-label">Name:</span>
                                    <span className="receipt-detail-value" style={{ fontWeight: "900" }}>{patientName}</span>
                                </div>
                                {patient.mobile && (
                                    <div className="receipt-detail-item">
                                        <span className="receipt-detail-label">Phone:</span>
                                        <span className="receipt-detail-value">{patient.mobile}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                     

                    </div>
                </div>
            </div>
        </div>
    );
});

export default Receipt;